import { SxProps, Theme } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const pagination: {
  paginationLegend: SxProps<Theme>;
} = {
  paginationLegend: {
    fontWeight: OpenSansFontWeights.light,
    color: "grey.500",
    b: {
      fontWeight: OpenSansFontWeights.semibold,
    },
  },
};
